import { todayStr } from '../lib/format.js';

// Events affecting this store in the next 7 days, from the kiosk dashboard
// payload (annual events already expanded server-side). Read-only.
//
// Restored from the old KioskDashboardView, which was deleted as unreachable
// on 2026-07-23 (14cd467) — taking the only place the kiosk drew events with
// it. The Today tab that replaced that dashboard never had the strip.
const ymd = (d) => String(d).slice(0, 10);

export function KioskEventsStrip({ events }) {
  if (!Array.isArray(events) || events.length === 0) return null;
  const today = todayStr();
  const onToday = events.filter(e => today >= ymd(e.start_date) && today <= ymd(e.end_date || e.start_date));
  const upcoming = events.filter(e => !onToday.includes(e)).slice(0, 4);
  return (
    <div style={{ background: '#fef9ee', border: '1px solid #f5e6c8', borderRadius: 12,
                    padding: 12, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: '#8e6c33',
                      textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        📅 Events
      </div>
      {onToday.map(e => (
        <div key={`kt-${e.id}-${e.start_date}`}
          style={{ background: '#fff', border: '1px solid #f0d9a3', borderRadius: 8,
                    padding: 10, fontSize: 14 }}>
          <div style={{ fontWeight: 600 }}>📍 Today: {e.title}</div>
          {e.notes && <div style={{ fontSize: 12, color: '#444', marginTop: 4 }}>{e.notes}</div>}
        </div>
      ))}
      {upcoming.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {upcoming.map(e => (
            <div key={`ku-${e.id}-${e.start_date}`}
              style={{ fontSize: 12, padding: '4px 10px', borderRadius: 99,
                        background: '#fff', border: '1px solid #e0d4a8', color: '#5a4220' }}>
              {new Date(ymd(e.start_date) + 'T12:00:00').toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })} · {e.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
